import { format, isValid, parseISO } from "date-fns";
import {
  BodyLarge,
  BodyMedium,
  BodySmall,
} from "../../components/StyledComponents/Typography/Typography.tsx";
import {
  DetailGroup,
  TableGroup,
  tableColumnsMapping,
} from "../../constants.js";
import { Tooltip, Box } from "@mui/material";
import React from "react";
export const returnDefaultColumnConfigs = () => {
  return {
    tableGroup: TableGroup,
    detailGroup: DetailGroup,
  };
};

export const returnDefaultColumnConfigsForTable = (colors) => {
  const renderCellFunctions = {
    IP: (params) => {
      return (
        <>
          <a
            href={`https://${params?.value}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              cursor: "pointer",
              color: colors?.text?.primary,
              fontWeight: 500,
              fontStyle: "bold",
            }}
            onClick={(event) => event.stopPropagation()}
          >
            {" "}
            <BodyLarge noWrap>{params?.value}</BodyLarge>{" "}
          </a>{" "}
        </>
      );
    },
    Warranty_Start: (params) => {
      if (!params?.value)
        return <BodyLarge noWrap>{""}</BodyLarge>;
      const warrantyStartDate = isValid(
        parseISO(params?.value)
      )
        ? format(parseISO(params?.value), "MM/dd/yyyy")
        : "";
      return <BodyLarge noWrap>{warrantyStartDate}</BodyLarge>;
    },
    Warranty_End: (params) => {
      if (!params?.value)
        return <BodyLarge noWrap>{""}</BodyLarge>;
      const warrantyEndDate = isValid(
        parseISO(params?.value)
      )
        ? format(parseISO(params?.value), "MM/dd/yyyy")
        : "";
      return <BodyLarge noWrap>{warrantyEndDate}</BodyLarge>;
    },
    UpTime: (params) => {
      let upTimeValue = "";
      let localDateStr = "";

      const msg = params?.value || "";
      const upTime = msg.split(",")[2]?.substr(8) || "";

      let months = 0,
        days = 0,
        hours = 0,
        minutes = 0,
        seconds = 0;

      const monthMatch = upTime.match(/([\d.]+)mo/);
      const dayMatch = upTime.match(/([\d.]+)d/);
      const hourMatch = upTime.match(/([\d.]+)h/);
      const minuteMatch = upTime.match(/([\d.]+)m/);
      const secondMatch = upTime.match(/([\d.]+)s/);

      if (monthMatch) months = parseFloat(monthMatch[1]);
      if (dayMatch) days = parseFloat(dayMatch[1]);
      if (hourMatch) hours = parseFloat(hourMatch[1]);
      if (minuteMatch) minutes = parseFloat(minuteMatch[1]);
      if (secondMatch) seconds = parseFloat(secondMatch[1]);

      const MINUTES_IN_YEAR = 525600;
      const MINUTES_IN_MONTH = 43800;
      const MINUTES_IN_DAY = 1440;

      let totalMinutes =
        months * MINUTES_IN_MONTH +
        days * MINUTES_IN_DAY +
        hours * 60 +
        minutes +
        seconds / 60;

      const yearsOut = Math.floor(
        totalMinutes / MINUTES_IN_YEAR
      );
      totalMinutes %= MINUTES_IN_YEAR;

      const monthsOut = Math.floor(
        totalMinutes / MINUTES_IN_MONTH
      );
      totalMinutes %= MINUTES_IN_MONTH;

      const daysOut = Math.floor(
        totalMinutes / MINUTES_IN_DAY
      );
      totalMinutes %= MINUTES_IN_DAY;

      const hoursOut = Math.floor(totalMinutes / 60);
      totalMinutes %= 60;

      const minutesOut = Math.round(totalMinutes);

      const upTimeObj = {
        y: yearsOut,
        mo: monthsOut,
        d: daysOut,
        h: hoursOut,
        m: minutesOut,
      };
      const filteredUpTimeObj = {};
      for (const key in upTimeObj) {
        if (upTimeObj[key] > 0) {
          filteredUpTimeObj[key] = upTimeObj[key];
        }
      }

      if (Object.keys(filteredUpTimeObj).length > 0) {
        upTimeValue = Object.entries(filteredUpTimeObj)
          .map(([key, value]) => `${value}${key}`)
          .join(" ");
      }

      // Extract and format local date from "Time:"
      const timeMatch = msg.match(/Time:\s+(.+?),/);
      if (timeMatch && timeMatch[1]) {
        const utcDate = new Date(timeMatch[1] + " UTC");
        if (!isNaN(utcDate)) {
          const localDate = new Date(utcDate);

          const now = new Date();
          const isToday =
            localDate.getFullYear() === now.getFullYear() &&
            localDate.getMonth() === now.getMonth() &&
            localDate.getDate() === now.getDate();

          if (!isToday) {
            const yyyy = localDate.getFullYear();
            const mm = String(
              localDate.getMonth() + 1
            ).padStart(2, "0");
            const dd = String(localDate.getDate()).padStart(
              2,
              "0"
            );
            const hh = String(
              localDate.getHours()
            ).padStart(2, "0");
            const min = String(
              localDate.getMinutes()
            ).padStart(2, "0");
            localDateStr = `${yyyy}-${mm}-${dd} ${hh}:${min}`;
          }
        }
      }
      return (
        <div>
          <BodyLarge noWrap>{upTimeValue}</BodyLarge>
          {localDateStr && (
            <BodyMedium noWrap>{localDateStr}</BodyMedium>
          )}
        </div>
      );
    },
    Status: (params) => {
      return <BodyLarge noWrap>{params?.value}</BodyLarge>;
    },
    THs: (params) => {
      return (
        <BodyLarge noWrap>
          {params?.value
            ? `${params.value} TH/s`
            : "0 TH/s"}
        </BodyLarge>
      );
    },
    Power: (params) => {
      return (
        <BodyLarge noWrap>
          {params?.value ? `${params.value} W` : "0 W"}
        </BodyLarge>
      );
    },
    JTHs: (params) => {
      return (
        <BodyLarge noWrap>
          {params?.value
            ? `${params.value} J/THs`
            : "0 J/THs"}
        </BodyLarge>
      );
    },
  };
  return Object.entries(tableColumnsMapping).map(
    ([headerName, field]) => {
      return {
        field: field,
        headerName: headerName,
        minWidth: 106,
        flex: 1,
        renderCell: renderCellFunctions[field]
          ? renderCellFunctions[field]
          : (params) => {
              return <BodyLarge noWrap>{params?.value}</BodyLarge>;
            },
      };
    }
  );
};

/**
 * Higher-order function that wraps a column's renderCell with a tooltip
 * @param {Function} renderCell - Original renderCell function
 * @param {string} headerName - Column header name
 * @param {string} field - Column field name
 * @param {Object} colors - Theme colors object
 * @returns {Function} Wrapped renderCell with tooltip
 */
export const withCellTooltip = (renderCell, headerName, field, colors) => {
  return (params) => {
    // Get the original cell content
    const cellContent = renderCell ? renderCell(params) : <BodyLarge noWrap>{params?.value}</BodyLarge>;

    // Format value for tooltip display
    const formatValueForTooltip = (value, headerName, row) => {
      // Special handling for Pools - show alive pool
      if (headerName?.toLowerCase() === 'pools') {
        const pools = [1, 2, 3];
        for (let i of pools) {
          const statusKey = `Pool${i}Status`;
          const urlKey = `Pool${i}URL`;
          const userKey = `Pool${i}User`;
          const protocolKey = `Pool${i}Protocol`;

          if (
            row[statusKey]?.toLowerCase?.() === 'alive' &&
            row[urlKey] &&
            row[userKey]
          ) {
            return (
              <>
                <BodyMedium sx={{ color: colors?.text?.primary, mb: 0.5 }}>
                  {row[urlKey]} ({row[protocolKey] || 'NA'})
                </BodyMedium>
                <BodyMedium sx={{ color: colors?.text?.primary }}>
                  {row[userKey]}
                </BodyMedium>
              </>
            );
          }
        }
        return '—';
      }

      if (value === null || value === undefined || value === '') {
        return '—';
      }

      if (Array.isArray(value)) {
        return value.length > 0 ? value.join(', ') : '—';
      }

      if (typeof value === 'object') {
        return JSON.stringify(value);
      }

      return String(value);
    };

    const displayValue = formatValueForTooltip(params?.value, headerName, params?.row);

    return (
      <Tooltip
        title={
          <Box sx={{ p: 2 }}>
            <BodySmall sx={{ color: colors?.text?.secondary, mb: 1 }}>
              {headerName}
            </BodySmall>
            <Box sx={{ color: colors?.text?.primary }}>
              {typeof displayValue === 'string' ? (
                <BodyMedium>{displayValue}</BodyMedium>
              ) : (
                displayValue
              )}
            </Box>
          </Box>
        }
        arrow
        placement="top"
        enterDelay={200}
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: colors?.background?.paper || 'rgba(33, 33, 33, 0.98)',
              '& .MuiTooltip-arrow': {
                color: colors?.background?.paper || 'rgba(33, 33, 33, 0.98)',
              },
              boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
              borderRadius: '1rem',
              maxWidth: 'none',
              padding: 0,
            },
          },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', height: '100%' }}>
          {cellContent}
        </Box>
      </Tooltip>
    );
  };
};
